import styled from 'styled-components';
const MobileViewDetailsWrapper = styled.div`
.m-view-details{
	background: #fff;
    padding: 20px;
    position: fixed;
    top: 90px;
	// max-width: 280px;
	width:75%;
	bottom: 20px;
	border-radius: 0 10px 10px 0;
	-webkit-animation: slide 0.5s forwards;
	-webkit-animation-delay: 2s;
	animation: slide 0.5s forwards;
	animation-delay: 2s;
	&.detail-slidein{
		transition: 0.4s;
        left: 0;
	}
	&.detail-slideout{
		left: -100%;
        transition: 0.4s;
	}
	header.m-videdetailsHeader{
		   display: flex;
			align-items: center;
			justify-content: space-between;
			padding:10px 0;
			border-bottom:1px solid rgba(52, 65, 119, 0.49);
			margin: 0 0 10px;
			.back-btn{
				width: 10px;
				position: absolute;
				top: 30px;
				cursor:pointer;
			}
		.header-field{
			padding: 0 0 0 25px;
			>h1{
				font-size: 14px;
				color: #344177;
				text-transform: capitalize;
				font-weight: 700;
			}
			>h2{
				font-size: 11px;
				color: #344177;
				font-weight: normal;
				padding: 3px 0 10px;
			}
		}
		.action{
			.visit-details{
				color: #ffffff;
				background: #4eb0de;
    			border: 1px solid #4eb0de;
			}
		}
	}
    .m-viewdetails-content{
        font-family:"open sans", sans-serif;
        .content{
            border-bottom:1.5px solid rgba(52, 65, 119, 0.35);
            .p-0{
                padding:0 !important;
              }
              h1{
                  font-size: 0.8em;
                  color:#344177;
                  text-transform:uppercase;
				  font-weight:700;
				  padding:0 0 5px;
              }
              h2{
                  font-size:0.9em;
                  color:#344177;
                  text-transform:capitalize;
                  font-weight:500;
                  padding:0 0 20px;
              }
              h4{
                font-size:0.95em;
                color:#b2b9d6;
                text-transform:capitalize;
                font-weight:500;
                padding:0 0 15px;
            }
              h3{
                font-size:1.1em;
                color:#344177;
                text-transform:capitalize;
                font-weight:600;
                padding:0;
            }
            h5{
                font-size: 0.85em;
                color: #e83c3c;
                text-transform: capitalize;
                font-weight: 600;
                padding: 0 0 10px;
                margin: 0;
            }
        }
        .actionWrapper{
            display:flex;
            align-items:center;
            margin:10px 0;
            .control{
                width:37px;
                height:37px;
                min-width:37px;
                border-radius:37px;
                margin-right:15px;
                cursor: pointer;
                text-align:center;
                display: flex;
                align-items: center;
                justify-content: center;
                &.connect{
                    background:#6eb56e;
                }
                &.disconnect{
                    background:#d05353;
                }
            }
        }
        .classifications{
            background:#f7f7f9;
            padding:5px 10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            flex-direction: row;
            .item{
                flex-basis: 50%;
                margin:2px 0;
                display: flex;
                align-items: center;
                >span{
                    color: #000;
                    margin-right: 5px;
                    >img{
                      
                    }
                }
                >h1{
                    font-size: 0.9em;
                    color: #344177;
                    font-weight: normal;
                    text-transform: capitalize;
                    font-weight: 700;
                    margin-bottom: 0px;
                }
            }
        }
    }
    .ant-popover-inner{
        border-radius:7px; 
        box-shadow: 0 0 30px 0 rgba(52, 65, 119, 0.35);
    }
}
.removeParticipant-btn{
    background:#d05353;
    padding: 0 15px;
    color: #fff;
    font-weight: bold;
    font-size: 0.75rem;
    border-radius: 10px;
    text-transform: uppercase;
    width:100%;
    margin-top: 15px;
    height:32px;
}
`;

export default (MobileViewDetailsWrapper);

